var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.defaultConfig)?_c('div',{attrs:{"anchor-popup-root":""}},_vm._l((_vm.popupItems),function(config,index){return _c('popupItem',{key:index,attrs:{"index":index,"config":config},on:{"close":_vm.close}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }